export default "__VITE_ASSET__Dk6t5O_d__"